import { LocalStorageService } from './../../core/services/local-storage.service';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { serverError } from './../../core/models/messages';
import { StripeService } from './../../core/services/stripeService/stripe-service.service';
import * as saveAs from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, finalize, takeUntil } from 'rxjs';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.css'],
})
export class InvoicesComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  invoiceId: any;
  listInvoice: any;
  searchElement: string = '';
  private unsubscribeAll: Subject<void> = new Subject();
  currentUser: any;
  stripe_id: any;

  currentPage: number = 0;
  pageSize = 5;
  pageSizeOptions = [5, 10, 20];

  startSearching:boolean  = false;
  totalItems!: number;

  constructor(
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private stripeService: StripeService,
    private toastr: ToastrService,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.getStripeId();
    this.getId();
    this.getListInvoice();
  }
  getStripeId() {
    this.currentUser = this.localStorageService.getData('UserInfo');
    this.stripe_id = JSON.parse(this.currentUser).stripe_id;
  }
  getId() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.invoiceId = params.params['abonnementId'];
      },
    });
  }

  getListInvoice() {

    let dataPayload = {
      per_page: this.pageSize,
      page: this.currentPage + 1,
      invoiceId: this.invoiceId,
    };

    this.spinner.show();
    this.stripeService
      .getAllDetailsOfInvoice(dataPayload)
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe(
        (res: any) => {
          this.listInvoice = res.data;
          //this.totalItems = res.data.total;
          this.spinner.hide();
        },
        (error) => {
          this.spinner.hide();
        }
      );
  }

  reset() {
    this.searchElement = '';
    this.startSearching = false;
    this.currentPage = 0
    this.getListInvoice();
  }

  downloadInvoice(invoiceId: any, file?: File) {
    let exportSuccess = false;
    let data = invoiceId;
    this.stripeService.exportInvoice(file, data).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        const blob = new Blob([res], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        saveAs(blob, 'Facture.pdf');
        exportSuccess = true;
        if (exportSuccess) {
          this.toastr.success('Fichier exporté avec succès');
        }
        ;
      },
      error: () => {
        this.spinner.hide();
        this.toastr.error(serverError);
      },
    });
  }

  applyFilter(pageNumber : number = this.currentPage) {
    let data = {
      per_page: this.pageSize,
      page: pageNumber + 1,
      search: this.searchElement?.trim().toLowerCase(),
    };
    this.spinner.show();
    this.stripeService
      .searchInvoice(data, this.invoiceId)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.listInvoice = res.data;
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

  getInvoiceStatusDisplay(status: string): { label: string, class: string } {
    switch (status) {
      case 'paid':
        return { label: 'Payé', class: 'paye' };
      case 'open':
        return { label: 'En attente de paiement', class: 'encours' };
      case 'draft':
        return { label: 'Brouillon', class: 'brouillon' };
      case 'uncollectible':
        return { label: 'Irrécouvrable', class: 'irrecoverable' };
      case 'void':
        return { label: 'Annulé', class: 'annule' };
      default:
        return { label: 'Inconnu', class: 'inconnu' };
    }
  }

   onPageChange(e: PageEvent): void {
      this.pageSize = e.pageSize;
      this.currentPage = e.pageIndex;
      if (this.startSearching) {
        this.applyFilter();
      } 
      else {
        this.getListInvoice();
      }
    }
    
}
